module.exports = __webpack_public_path__ + "img/example.a64f4950.png";